import { Button, Divider, Grid } from '@mui/material';
import Modal from 'components/shared/Modal';
import React, { useMemo } from 'react';
import { ModalProps } from 'store/types/ComponentProps';
import { defaultGridContainerProps, defaultGridItemProps } from 'util/Layout';
import { getApplicationStatusLabel } from 'util/Application';
import { getFormattedDate } from 'util/Format';
import { getHashRouteUrl } from 'util/Route';
import routes from 'store/configs/Routes';
import Application from 'store/types/Application';
import ApplicationStatus from 'store/enums/ApplicationStatus';

import styles from './ApplicationDecisionModal.module.scss';

interface ApplicationDecisionModalProps extends ModalProps {
  application: Application;
  showNavigation?: boolean;
}

const ApplicationDecisionModal: React.FunctionComponent<ApplicationDecisionModalProps> = ({
  open,
  application,
  showNavigation = false,
  onClose,
}) => {
  const openApplicationLink: string = useMemo(
    () =>
      application.status === ApplicationStatus.InformationRequired ? routes.editApplication : routes.viewApplication,
    [application.status]
  );

  return (
    <Modal
      open={open}
      onClose={onClose}
      maxWidth={'sm'}
      title={'Decision'}
      actions={
        <>
          <Button color={'secondary'} variant={'outlined'} onClick={onClose}>
            {'Close'}
          </Button>
          {showNavigation && application.id && (
            <Button
              color={'secondary'}
              variant={'contained'}
              href={getHashRouteUrl(`${openApplicationLink}/${application.id}`)}
            >
              {'Go to Application'}
            </Button>
          )}
        </>
      }
    >
      <Grid {...defaultGridContainerProps}>
        <Grid {...defaultGridItemProps}>
          <div className={styles.status}>
            <span className={styles.title}>{'Application Status: '}</span>
            <span className={styles.value}>{getApplicationStatusLabel(application.status)}</span>
          </div>
          <div className={styles.status}>
            <span className={styles.title}>{'Date: '}</span>
            <span className={styles.value}>{getFormattedDate(application.decisionDate || '')}</span>
          </div>
          {application.decisionComment && (
            <>
              <span className={styles.comment}>{'Comment '}</span>
              <Divider className={styles.divider} />
              <span>{application.decisionComment}</span>
            </>
          )}
        </Grid>
      </Grid>
    </Modal>
  );
};
export default ApplicationDecisionModal;
